import axios from 'axios';

export const configAxios = (store) => {
  axios.interceptors.request.use(function (config) {
    if (!/localhost/.test(config.url) && (!/sellingpower\.com/.test(config.url) || /sendy/.test(config.url))) return config;

    const { token } = store.getState();
    if (token) config.headers.common.Authorization = `Bearer ${token}`;

    return config;
  });
};



// WEBPACK FOOTER //
// ./src/config/axios.js